module.exports = __webpack_public_path__ + "img/paymentRecords.117e9352.png";